(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-juju"] && !Shopify.designMode) return;
  try {
    
// Prices are in the shop's presentment-currency minor units.
function selectJujuProducts(items, audience, use, position, giftMode = false) {
  const seen = new Set();
  const eligible = items.filter(item => {
    if (!item.uses.split(',').includes(use) || !['both', audience].includes(item.audience) || seen.has(item.id)) return false;
    seen.add(item.id); return true;
  }).sort((a, b) => a.price - b.price);
  if (position === 25) return { matches: eligible.slice().reverse().slice(0, 3), alternative: false, premium: true };
  const ceiling = position * 5000;
  const floor = Math.max(0, ceiling - 10000);
  const under = eligible.filter(p => p.price < ceiling).reverse();
  if (use === 'night' && !under.length && eligible.length) return { matches: [eligible[0]], alternative: true, nightBudget: true, premium: false };
  if (giftMode) return { matches: under.slice(0, 3), alternative: false, premium: false };
  const near = under.filter(p => p.price >= floor);
  const upgrade = eligible.find(p => p.price >= ceiling && p.price * 10 <= ceiling * 11);
  if (under.length) return {
    matches: (near.length ? near : under).slice(0, upgrade ? 2 : 3),
    upgrade, alternative: false, premium: false, lowerBudget: !near.length
  };
  if (upgrade) return { matches: [upgrade], alternative: true, premium: false };
  return { matches: [], alternative: false, premium: false };

}
function initializeJuju(scope = document) {
  scope.querySelectorAll('[data-juju]').forEach(root => {
    const form = root.querySelector('[data-form]');
    if (!form || root.dataset.ready) return;
    root.dataset.ready = 'true';
    let steps = [...form.querySelectorAll('[data-step]')];
    const giftMode = new URLSearchParams(window.location.search).get('juju_mode') === 'gift';
    const next = form.querySelector('[data-next]');
    const back = form.querySelector('[data-back]');
    const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
    if (giftMode) {
      const [audienceStep, useStep, budgetStep] = steps;
      audienceStep.removeAttribute('data-step');
      audienceStep.hidden = false;
      audienceStep.disabled = false;
      useStep.append(audienceStep);
      steps = [budgetStep, useStep];
      root.querySelector('[data-journey-title]').textContent = labels.gift_title;
      root.querySelector('[data-journey-intro]').textContent = labels.gift_intro;
      root.querySelector('[id^="juju-budget-note-"]').textContent = labels.gift_budget_note;
      form.querySelector('[data-step-total]').textContent = '2';
    }
    const slider = form.elements.budget;
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency:root.dataset.currency || 'EUR',maximumFractionDigits:2}).format(value / 100);
    const text = (key, values = {}) => Object.entries(values).reduce((str, [k,v]) => str.replaceAll('__'+k.toUpperCase()+'__',v), labels[key]);
    const budgetLabel = position => text(position === 25 ? 'over' : 'under', {price: money(position === 25 ? 120000 : position*5000)});
    function updateBudget() { const value=budgetLabel(Number(slider.value)); root.querySelector('[data-budget-value]').textContent=value;slider.setAttribute('aria-valuetext',value); }
    root.querySelector('[data-budget-first]').textContent=budgetLabel(1);
    root.querySelector('[data-budget-last]').textContent=budgetLabel(25);
    slider.addEventListener('input',updateBudget);updateBudget();
    const frames=['anim1.png?v=1716971903','anim3.png?v=1716971903','anim55.png?v=1717514550','anim3.png?v=1716971903','anim5.png?v=1716971904','anim6.png?v=1716971904'].map(name=>'https://cdn.shopify.com/s/files/1/0773/1016/5332/files/'+name);
    let step=0, timer=null;
    function showStep(n, focus = true) {
      step=n;steps.forEach((el,i)=>{el.hidden=i!==n;el.disabled=i!==n});back.hidden=n===0;
      next.textContent=n===steps.length-1?labels.results:labels.next;
      form.querySelector('[data-step-number]').textContent=String(n+1);if(focus)steps[n].querySelector('legend').focus();
      if(n===steps.length-1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) frames.forEach(src=>{const img=new Image();img.src=src;});
    }
    form.addEventListener('change',()=>{form.querySelector('[data-hunting]').hidden=form.elements.use.value!=='hunt';const isSea=form.elements.use.value==='sea';form.querySelector('[data-marine]').hidden=!isSea;form.elements.marine.disabled=!isSea;});
    back.addEventListener('click',()=>showStep(Math.max(0,step-1)));
    function revealResults() {
      clearInterval(timer);timer=null;root.querySelector('[data-thinking]').hidden=true;
      root.querySelector('[data-results]').hidden=false;root.querySelector('[data-result-heading]').focus();
    }
    form.addEventListener('submit',event=>{
      event.preventDefault();if(timer || !form.reportValidity())return;
      if(step<steps.length-1){showStep(step+1);return;}
      const audience=form.elements.audience.value, use=form.elements.use.value;
      const useKey=use==='hunt'?'hunt_'+form.elements.hunting.value:use==='sea'&&form.elements.marine.value==='shore'?'shore':use;
      const position=Number(slider.value), ceiling=position*5000;
      const items=[...root.querySelectorAll('template[data-product]')].map(t=>({id:t.dataset.productId,price:Number(t.dataset.price),uses:t.dataset.uses,audience:t.dataset.audience,template:t}));
      const selection=selectJujuProducts(items,audience,useKey,position,giftMode);
      const products=root.querySelector('[data-products]');products.replaceChildren();
      selection.matches.forEach(p=>products.append(p.template.content.cloneNode(true)));
      const upgrade=root.querySelector('[data-upgrade]');upgrade.hidden=!selection.upgrade;
      const upgradeProducts=root.querySelector('[data-upgrade-products]');upgradeProducts.replaceChildren();
      if(selection.upgrade){root.querySelector('[data-upgrade-note]').textContent=text('upgrade',{price:money(selection.upgrade.price),difference:money(selection.upgrade.price-ceiling)});upgradeProducts.append(selection.upgrade.template.content.cloneNode(true));}
      const empty=root.querySelector('[data-empty]');empty.hidden=selection.matches.length>0;empty.textContent=giftMode?labels.gift_empty:labels.empty;
      const order=root.querySelector('[data-results-order]');order.hidden=!selection.matches.length || selection.alternative;
      order.textContent=giftMode?labels.gift_order:selection.lowerBudget?labels.lower_budget:selection.premium?text('premium',{price:money(120000)}):text('band',{lower:money(Math.max(0,ceiling-10000)),upper:money(ceiling)});
      const alternative=root.querySelector('[data-alternative]');alternative.hidden=!selection.alternative;
      alternative.textContent=selection.alternative?text(selection.nightBudget?'night_budget':selection.matches[0].price===ceiling?'at_limit':'alternative',{price:money(selection.matches[0].price),difference:money(selection.matches[0].price-ceiling)}):'';
      root.querySelector('[data-child-note]').hidden=audience!=='child';
      root.querySelector('[data-reason]').textContent=selection.matches.length?(useKey==='shore'?labels.reason_shore:labels.reasons[use]):'';
      root.querySelector('[data-summary]').textContent=form.querySelector('input[name="use"]:checked').parentElement.textContent.trim()+(use==='sea'?' — '+form.elements.marine.selectedOptions[0].textContent:'')+' · '+budgetLabel(position);
      form.hidden=true;
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){revealResults();return;}
      const thinking=root.querySelector('[data-thinking]'),owl=root.querySelector('[data-owl]');thinking.hidden=false;owl.src=frames[0];
      let index=0;timer=setInterval(()=>{index++;if(index>=frames.length){revealResults();return;}owl.src=frames[index];},250);
    });
    root.querySelector('[data-restart]').addEventListener('click',()=>{clearInterval(timer);timer=null;root.querySelector('[data-results]').hidden=true;root.querySelector('[data-thinking]').hidden=true;form.hidden=false;showStep(0)});
    root.addEventListener('shopify:section:unload',()=>clearInterval(timer));
    showStep(0, false);
    next.disabled=false;
  });
}
initializeJuju();
document.addEventListener('shopify:section:load',event=>initializeJuju(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
